module.exports = __webpack_public_path__ + "img/13.84a46fdd.png";